export const getFileExtensionFromMimeType = (mimeType: string): string => {
  // Common MIME type to extension mappings
  const mimeToExtension: Record<string, string> = {
    // Images
    "image/jpeg": "jpg",
    "image/jpg": "jpg",
    "image/png": "png",
    "image/gif": "gif",
    "image/webp": "webp",
    "image/svg+xml": "svg",
    "image/bmp": "bmp",
    "image/tiff": "tiff",
    "image/ico": "ico",

    // Videos
    "video/mp4": "mp4",
    "video/mpeg": "mpeg",
    "video/quicktime": "mov",
    "video/x-msvideo": "avi",
    "video/webm": "webm",
    "video/ogg": "ogv",
    "video/3gpp": "3gp",
    "video/x-flv": "flv",

    // Audio
    "audio/mpeg": "mp3",
    "audio/wav": "wav",
    "audio/ogg": "ogg",
    "audio/mp4": "m4a",
    "audio/webm": "webm",
    "audio/flac": "flac",
    "audio/aac": "aac",

    // Documents
    "application/pdf": "pdf",
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      "docx",
    "application/vnd.ms-excel": "xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "application/vnd.ms-powerpoint": "ppt",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      "pptx",
    "text/plain": "txt",
    "text/html": "html",
    "text/css": "css",
    "text/javascript": "js",
    "application/javascript": "js",
    "application/json": "json",
    "application/xml": "xml",
    "text/xml": "xml",

    // Archives
    "application/zip": "zip",
    "application/x-rar-compressed": "rar",
    "application/x-7z-compressed": "7z",
    "application/x-tar": "tar",
    "application/gzip": "gz",

    // Other common types
    "application/octet-stream": "bin",
  };

  // Normalize MIME type (remove charset and other parameters)
  const normalizedMimeType = mimeType.split(";")[0].trim().toLowerCase();

  // Return the extension if found, otherwise try to extract from the subtype
  if (mimeToExtension[normalizedMimeType]) {
    return mimeToExtension[normalizedMimeType];
  }

  // Fallback: try to use the subtype as extension
  const parts = normalizedMimeType.split("/");
  if (parts.length === 2) {
    const subtype = parts[1];
    // Handle compound subtypes (e.g., "vnd.ms-excel" -> "excel")
    const lastPart = subtype.split(".").pop() || subtype;
    return lastPart;
  }

  // Final fallback
  return "bin";
};
